import {CompanyExpiry, CompanyExpiryRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {COLOR_DISMISSED} from "../../../../components/layout/colors";
import {TableCell, Typography} from "@mui/material";
import dayjs from "dayjs";
import {useApiManager} from "../../../../components/utils/api";
import {dateToString} from "../../../../components/utils/dates";
import {fullName, SoftChip} from "../../../../components/kit";
import React from "react";
import {EXPIRY_CATEGORY_LABELS} from "./labels";

/** Caducidades de la empresa (#14017): avisan a su responsable, o a dirección, a 60, 30, 14, 7, 3, 1 y 0 días. */
export const CompanyExpiryListPage = () => {
	const apiManager = useApiManager();

	const listConfig: AppListConfig<CompanyExpiry> = {
		title: "Caducidades de la empresa",
		onClick: "/app/admin/compliance/expiry",
		headers: [
			{title: "Qué"},
			{title: "Tipo", width: 150},
			{title: "Caduca", width: 150},
			{title: "Responsable"},
		],
		decorator: (bean: CompanyExpiry) => {
			const days = dayjs(bean.expirationDate).diff(dayjs().startOf("day"), "day");
			return (
				<>
					<TableCell style={{color: bean.dismissed ? COLOR_DISMISSED : ""}}>
						<Typography variant="body2" fontWeight={600}>{bean.name}</Typography>
					</TableCell>
					<TableCell><Typography variant="body2">{EXPIRY_CATEGORY_LABELS[bean.category] || bean.category}</Typography></TableCell>
					<TableCell>
						<Typography variant="body2" sx={{fontVariantNumeric: "tabular-nums"}}>{dateToString(bean.expirationDate)}</Typography>
						{days <= 60 && <SoftChip tone={days < 0 ? "error" : "warning"} label={days < 0 ? "Caducado" : `En ${days} días`}/>}
					</TableCell>
					<TableCell>
						<Typography variant="body2" color={bean.responsible?.id ? undefined : "text.secondary"}>
							{bean.responsible?.id ? fullName(bean.responsible) : "Dirección"}
						</Typography>
					</TableCell>
				</>
			);
		},
		supplier: async (currentPage, size, term, showDismissed) => {

			const ctrl = apiManager.factory(CompanyExpiryRestControllerApiFactory);
			return ctrl.pageCompanyExpiry(currentPage, size, undefined, term, showDismissed);
		},
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};
